export default {
      id: "ic-para-silhouette-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-silhouette-usage",
      toString: function () {
        return this.url;
      }
    }